import { useLoginVerifyQuery } from '../../__generated__/chirp/com/hubspot/portals/platform/app/rpc/AccessRpc.hooks';
import { getIsThemePreview, getPortalAccountId, getPortalInstanceId } from '../utils/metadata';
import { usePortalsPlatformObjectId } from '../context/PortalsPlatformObjectIdContext';
export function useIsUngated(gate) {
  var _loginVerifyData$feat, _loginVerifyData$feat2;
  const accountId = getPortalAccountId();
  const portalInstanceId = getPortalInstanceId();
  const isThemePreview = getIsThemePreview();
  const objectId = usePortalsPlatformObjectId();
  const {
    data: loginVerifyData
  } = useLoginVerifyQuery({
    variables: {
      accountId,
      portalInstanceId,
      objectId
    },
    skip: isThemePreview
  });
  return (_loginVerifyData$feat = loginVerifyData === null || loginVerifyData === void 0 || (_loginVerifyData$feat2 = loginVerifyData.featuresEnabled) === null || _loginVerifyData$feat2 === void 0 ? void 0 : _loginVerifyData$feat2.includes(gate)) !== null && _loginVerifyData$feat !== void 0 ? _loginVerifyData$feat : false;
}